<template>
  <div ref="video-sdk-container" id="video-sdk-container" class="tw-min-h-[50vh]"></div>
</template>

<script>
// import { VideoSDK } from "@videosdk.live/js-sdk";
import { VideoSDKMeeting } from '@videosdk.live/rtc-js-prebuilt';

export default {
  name: 'VideoSdk',
  props: {
    meeting: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      videoSDKMeeting: undefined,
    };
  },
  computed: {
    userIsAdmin() {
      return Number(this.meeting.dash) === 1;
    },
  },
  async mounted() {
    this.videoSDKMeeting = new VideoSDKMeeting();

    this.videoSDKMeeting.init({
      apiKey: process.env.VUE_APP_VIDEO_SDK_API_KEY,
      meetingId: this.meeting.linkid,
      name: this.$store.state.User.name,
      containerId: 'video-sdk-container',
      redirectOnLeave: this.isSuperAdmin
        ? `${window.location.origin}/app/companies/edit/${this.meeting.companyid}/video-meetings`
        : `${window.location.origin}/app/my-license/mentorship/video-meetings`,
      micEnabled: true,
      webcamEnabled: true,
      participantCanToggleSelfWebcam: true,
      participantCanToggleSelfMic: true,
      participantCanLeave: true,
      chatEnabled: true,
      screenShareEnabled: true,
      joinScreen: {
        visible: false,
        title: this.meeting.title,
        meetingUrl: window.location.href,
      },
      permissions: {
        endMeeting: this.userIsAdmin, // meeting owner only feature
      },
    });

    await this.$nextTick();

    if (this.userIsAdmin) {
      // * fire start meeting here?
    }
  },
  beforeDestroy() {
    this.videoSDKMeeting = undefined; // ? cleanup?
  },
};
</script>

<style>

#video-sdk-container iframe {
  height: 75vh;
}

</style>
